import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Asterisk = ({ className = "h-5 w-5 text-brand-coral" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M12 2v20M2 12h20M4.9 4.9l14.2 14.2M19.1 4.9L4.9 19.1"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
  </svg>
);

export const RainbowMark = ({ className = "h-8 w-12" }) => (
  <svg viewBox="0 0 48 32" fill="none" className={className} aria-hidden="true">
    <path d="M5 27a19 19 0 0 1 38 0" stroke="#F57A7A" strokeWidth="4.5" strokeLinecap="round" />
    <path d="M12.5 27a11.5 11.5 0 0 1 23 0" stroke="#FDE68A" strokeWidth="4.5" strokeLinecap="round" />
    <path d="M20 27a4 4 0 0 1 8 0" stroke="#3A5A8C" strokeWidth="4.5" strokeLinecap="round" />
  </svg>
);

export const ChapterHeading = ({ number, eyebrow, title, accent, testid }) => (
  <div className="mb-12 md:mb-16" data-testid={testid}>
    <Reveal>
      <div className="flex items-center gap-3 mb-5">
        <Asterisk className="h-4 w-4 text-brand-coral" />
        <span className="text-sm uppercase tracking-[0.22em] font-medium text-brand-coral">
          Chapter {number} — {eyebrow}
        </span>
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-brand-blue leading-[1.05]">
        {title} {accent && <em className="text-brand-coral font-medium">{accent}</em>}
      </h2>
    </Reveal>
  </div>
);
